import { render } from "./App.vue?vue&type=template&id=43e9063a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=43e9063a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__